import { SET_USER, LOGOUT_USER } from 'context/constants';

const init = {
    isLogin: false,
    token: localStorage.getItem('token') || null,
    user: {},
}

export default (state = init, { type, ...user }) => {
    switch (type) {
        case SET_USER:
            return user;
        case LOGOUT_USER:
            return init;
        default:
            return state;
    }
}